import { createContext } from "react";

export interface SideBarContextState {
  open: boolean;
  toggle: () => void;
}

export const SideBarContext = createContext<SideBarContextState>({
  open: true,
  toggle: () => {},
});
